/*
 * History
 * Description:
 * Module to manage popups
 *
 * Purpose: When back button is pressed while popup is open, browser navigates back to previous page instead of closing the popup
 * 
 * @authors: Chiran Doshi and Elton Jain
 */

define('History',['jquery', 'UI','Helper'], function($, UI, Helper) {

    'use strict';
    var defaults = {
        url: '',
        title: 'Popup',
        popupId: null,
        state: null,
        // isPage: true,
        removeEl: true,
        callback: null
    },
    // o = {},
    _STACK = [],
    _CURRENT_ITEM = null,
    _isInitialSafariEvent = false,
    // popupIds = [],
    pushState = function(options) {
        // Check if required parameters are set. If not throw error
        // if (!options.popupId) {
        //     throw ('Data List : Pass arguments correctly');
        // }
        var o = $.extend({}, defaults, options);

        /* ////////////
         * Quick patch
         * Considering this is an overlay popup producing noscroll
         * ////////////
        */
        if(UI.$h.is('.safari')) {
            UI.$h.addClass('fixed');
        }
        o.url = o.url || window.location.href;
        _STACK.push(o);
        _CURRENT_ITEM = o;

        if (window.history && window.history.pushState) {
            history.pushState(o.state, o.title, o.url);
        }
    },

    popUpClose = function(o) {
        if(!o) {
            return false;
        }
        var $ele = $('#' + o.popupId);

        if($ele.length) {
            if (o.removeEl) {
                $ele.fadeOut('fast', function() {
                    $ele.remove();
                });
            } else if ($ele.is('.open')) {
                $ele.removeClass('open');
            } else if (!o.removeEl) {
                $ele.fadeOut('fast');
            }
        }
        if(getPopupCount() <= 1) {
            UI.noscroll(false);
        }
    },
    popState = function(callback) {
        if(_CURRENT_ITEM) {
            if(callback && !_CURRENT_ITEM.callback) {
                _CURRENT_ITEM.callback = callback;
            }

            if(_CURRENT_ITEM.popupId === undefined) {
                return;
            }
        }

        if (window.history && window.history.pushState) {
            history.go(-1);
        }
    },
    getPopupCount = function () {
        return _STACK.length || 0;
    },

    /**
     * [clearState Clear history state without going back and executing a callback]
     * @return nothing
     */
    clearStates = function (steps, callback) {
        steps = steps || 1;
        for(var i=0; i< steps; i++) {
            if(_STACK.length) {
                _STACK.pop();
            }
        }
        if(callback) {
            callback();
        }
    };

    window.onpopstate = function(ev) {
        var o = _STACK.pop();
        
        if(!o) {
            return true;
        }

        if(o.popupId) {
            popUpClose(o);
        }
        if(o.callback) {
            o.callback(_STACK);
        }
        _CURRENT_ITEM = _STACK[_STACK.length-1] || null;
    };

    return {
        pushState: pushState,
        popState: popState,
        clearStates: clearStates,
        getPopupCount: getPopupCount
    };
});
